export default __webpack_public_path__ + "static/media/leftist-mobile.b66d5f26.jpg";